import { useEffect, useRef, useState } from "react";

export default function useReveal(options = {}) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;
        const obs = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    obs.disconnect();
                }
            },
            { threshold: 0.15, ...options },
        );
        obs.observe(node);
        return () => obs.disconnect();
    }, [options]);

    return { ref, visible };
}
